// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__37pjQ","log":"ModalInventoryLogs_log__3IsbV","date":"ModalInventoryLogs_date__34n6c","userName":"ModalInventoryLogs_userName__3hHye"};